import { each, go, isNil, mapL, rejectL } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { TransformManipulator } from "../public/TransformManipulator.js";
export const progressSelectionScaleTransform = ({
  els,
  svg_el,
  sx,
  sy,
  x_axis_vec,
  y_axis_vec,
  origin_point,
  transform_manipulator,
}) => {
  const scale_transform = svg_el.createSVGTransform();
  scale_transform.setScale(sx, sy);
  const post_transform_matrix = svg_el.createSVGMatrix();
  post_transform_matrix.a = x_axis_vec.x;
  post_transform_matrix.b = x_axis_vec.y;
  post_transform_matrix.c = y_axis_vec.x;
  post_transform_matrix.d = y_axis_vec.y;
  post_transform_matrix.e = origin_point.x;
  post_transform_matrix.f = origin_point.y;
  const pre_transform_matrix = post_transform_matrix.inverse();
  const matrix = post_transform_matrix
    .multiply(scale_transform.matrix)
    .multiply(pre_transform_matrix);
  const is_multiple = els.length > 1;
  go(
    els,
    mapL((el) => ({
      el,
      el_ctm: el.getCTM(),
    })),
    rejectL(({ el_ctm }) => isNil(el_ctm)),
    mapL(({ el, el_ctm }) => {
      const fixed_transform = transform_manipulator.getFixedTransform(el);
      const before_base_transform =
        transform_manipulator.getBeforeBaseTransform(el);
      if (fixed_transform == null || before_base_transform == null) {
        return {
          el,
          el_ctm,
          el_fixed_transform_matrix:
            CommonNS.UtilNS.getConsolidatedTransformMatrix(el) ??
            svg_el.createSVGMatrix(),
        };
      }
      const { matrix: fixed_transform_matrix } = fixed_transform;
      const { matrix: before_base_transform_matrix } = before_base_transform;
      return {
        el,
        el_ctm,
        el_fixed_transform_matrix: is_multiple
          ? CommonNS.UtilNS.getConsolidatedTransformMatrix(el) ??
            svg_el.createSVGMatrix()
          : before_base_transform_matrix.multiply(fixed_transform_matrix),
      };
    }),
    mapL(({ el, el_ctm, el_fixed_transform_matrix }) => ({
      el,
      el_transform_matrix: el_fixed_transform_matrix
        .multiply(el_ctm.inverse())
        .multiply(matrix)
        .multiply(el_ctm)
        .multiply(el_fixed_transform_matrix.inverse()),
    })),
    each(({ el, el_transform_matrix }) => {
      is_multiple
        ? transform_manipulator.setExtendedTransformAfterBase(
            el_transform_matrix,
            el
          )
        : transform_manipulator.setExtendedTransformBeforeBase(
            el_transform_matrix,
            el
          );
      el.dispatchEvent(
        new CustomEvent(`@mp/sticker-editor/transform`, {
          bubbles: true,
          cancelable: true,
          composed: false,
          detail: {
            el,
            transform_type: "scale",
            transform_status: "progress",
          },
        })
      );
    })
  );
  return matrix;
};
